









import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';

export const baseDocumentationInputOptions = {
    stored: '',
    available: '',
}

@Component
export default class DocumentationInput extends Vue {
    static COMPONENT_NAME = 'documentation-input'

    @Prop({type: String, required: true}) label!: string
    @Prop({type: Object, required: true}) options!: Record<string, string>
    @Prop({type: String, default: 'All related documentation is electronically stored and clearly identifiable (i.e. indexed/clear file names)'}) storedLabel!: string
    @Prop({type: String, default: 'All related documentation is promptly available without having to consult with anyone outside the senior team'}) availableLabel!: string
    @Prop({type: Boolean, default: true}) appendLabel!: boolean

    get appendedLabel(): string {
        return `${this.label}${this.appendLabel ?'; do you agree with the following statements?' : ''}`
    }

    get appendedOptions(): Record<string, string> {
        const options = {
            ...this.options,
            ...baseDocumentationInputOptions,
        };
        options.stored = this.storedLabel;
        options.available = this.availableLabel;

        return options;
    }
}
